import { render, staticRenderFns } from "./ILclList.vue?vue&type=template&id=efdeb1d6&scoped=true"
import script from "./ILclList.vue?vue&type=script&lang=js"
export * from "./ILclList.vue?vue&type=script&lang=js"
import style0 from "./ILclList.vue?vue&type=style&index=0&id=efdeb1d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdeb1d6",
  null
  
)

export default component.exports